/* eslint-disable jsx-a11y/label-has-for */

import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CONSTANTS from '@/utils/Constants/General';
import { calculateFilterColor } from '@/utils/Common/ListingUtils';

import { useListingContext } from '@/context/listing';
import useOnClickOutside from '@/hooks/useOnClickOutside';

const FilterColorItem = ({ filter }) => {
  const { t } = useTranslation();
  const [isFilterOpen, setFilterOpen] = useState(false);

  const ref = useRef();
  useOnClickOutside(ref, () => {
    if (window.innerWidth >= CONSTANTS.BREAKPOINTS.DELONGHI.M) {
      setFilterOpen(false);
    }
  });

  const [, { pushQuery }] = useListingContext();

  const appliedFiltersCount = filter.values.reduce(
    (accFilters, filterValue) =>
      filterValue.selected ? accFilters + 1 : accFilters,
    0,
  );

  return (
    <div
      ref={ref}
      className='del-plp-filters__filter'
      key={`${filter.code}-filter`}
    >
      <button
        type='button'
        className='del-button del-plp-filters__filter-title'
        onClick={() => setFilterOpen(!isFilterOpen)}
        key={`${filter.code}-button`}
      >
        {filter.name} {appliedFiltersCount ? `(${appliedFiltersCount})` : null}{' '}
        <i
          key={`${filter.code}-icon`}
          className={`del-plp-filters__sort-button-icon del-icon ${
            isFilterOpen ? 'icon-select-up' : 'icon-select-down'
          }`}
        />
      </button>
      {isFilterOpen ? (
        <div
          className='del-plp-filters__filter-menu'
          key={`${filter.code}-filter-menu`}
        >
          {filter.values.map(filterValue => {
            const { name, style } = calculateFilterColor(filterValue.name);
            return (
              <button
                type='button'
                className='del-button del-plp-filters__filter-item'
                key={`${filterValue.code}-filter-item`}
                onClick={() => pushQuery(filterValue.query)}
              >
                <div
                  style={style}
                  className='del-plp-filters__color-preview'
                  key={`${filter.code}-color`}
                />
                <span
                  className={`del-plp-filters__filter-label ${
                    filterValue.selected
                      ? 'del-plp-filters__filter-label--selected'
                      : ''
                  }`}
                  key={`${filter.code}-label`}
                >
                  {name}{' '}
                  <span
                    className='del-plp-filters__filter-count'
                    key={`${filter.code}-count`}
                  >
                    ({filterValue.count})
                  </span>
                </span>
              </button>
            );
          })}
          <div className='del-plp-filters__filter-item-apply-row'>
            <button
              type='button'
              className='del-button del-button--primary-black del-button--small del-plp-filters__filter-item-apply-button'
              onClick={() => setFilterOpen(false)}
            >
              {t('listing:listing.apply.filters.cta.label')}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

FilterColorItem.propTypes = {
  filter: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default FilterColorItem;
